import { getAssetPath } from "@commonUtils"

export const gatewayPrefix = "/api/labs/"
export const labsPrefix = "/labs/"
export const PATHOLOGY = "Pathology"
export const RADIOLOGY = "Radiology"
export const PACKAGE_FALLBACK =
    "https://onemg.gumlet.io/assets/c1300fd4-6225-11ec-9a31-0291ea084bb0.png?format=auto"
export const CITY_NOT_SERVICEABLE =
    "https://onemg.gumlet.io/assets/f0a66e5c-687e-11ec-bd96-0a378785e92c.png?format=auto"
export const TEST_NOT_ACTIVE =
    "https://onemg.gumlet.io/assets/bf2595d6-6880-11ec-9597-0291ea084bb0.png?format=auto"
export const TEST_INACTIVE =
    "https://onemg.gumlet.io/assets/ccd0d2ee-790c-11ec-8042-023cc772570e.svg?format=auto"
export const SEARCH_PATH = "/labs/search"
export const INVENTORY_PATH = "/labs/inventory"
export const CART_PATH = "/labs/cart"
export const HOME_PATH = "/labs"
export const PDP_PATH = "/labs/test"
export const CATGEORY_TEST_PATH = "/labs/tests"
export const TEST_ICON = getAssetPath("svgs/icons/test.svg")
export const FUNNEL_ICON = getAssetPath("svgs/icons/package.svg")
export const ERROR_ICON = getAssetPath("illustrations/no-longer-available.svg")
export const NO_RESULT = getAssetPath("illustrations/no-result-found.svg")
export const WEBVIEW_CART_PATH = "onemg://www.1mg.com/labs/cart"
export const DEFAULT_ERROR_MESSAGE = "Sorry, something went wrong. Please try again."
export const SNACK_BAR_DELAY_TIME = 3000

// export const stickyFooterAllowedPaths = [SEARCH_PATH, HOME_PATH, PDP_PATH, CATGEORY_TEST_PATH]
/**
    If someday we want to move <StickyFooter />
    to the shell then we just want to add path
    here for the routes where we want to enable it
**/

export const throwError = (type) => {
    const error = {
        is_success: false,
        status_code: 400,
        error: {
            errors: [
                {
                    type: type,
                },
            ],
        },
    }
    return error
}

export const APIEndpoints = {
    SAMPLE_COLLECTED: {
        uri: (collection_pool_code) => {
            return `${gatewayPrefix}v1/scps/${collection_pool_code}`
        },
        method: "GET",
    },
    FEEDBACK: {
        uri: (collection_pool_code) => {
            return `${gatewayPrefix}v1/scps/${collection_pool_code}/feedback`
        },
        method: "PUT",
    },
    RATING: {
        uri: (collection_pool_code) => {
            return `${gatewayPrefix}v1/scps/${collection_pool_code}/rating`
        },
        method: "PUT",
    },

    CATEGORY_LISTING: {
        uri: (payload) => {
            return `${gatewayPrefix}v1/inventory?page_number=${payload.offset}&city=${payload.city}&sort_by=${payload.sortValue}&page_size=${payload.limit}&test_type=${payload.testType}&browse_by=${payload.browseBy}&browse_by_id=${payload.browseById}&labs=${payload.labs}&category=${payload.category}`
        },
    },
    SEARCH_SUGGESTION: {
        uri: () => {
            return `${gatewayPrefix}v1/search/suggestions`
        },
        method: "GET",
    },
    SEARCH: {
        uri: () => {
            return `${gatewayPrefix}v1/search/auto-complete`
        },
        method: "GET",
    },
    INVENTORIES: {
        uri: () => {
            return `${gatewayPrefix}v1/labs/options`
        },
        method: "GET",
    },
    CART_REPLACE: {
        uri: () => {
            return `api/v4/carts/replace?types=labs`
        },
        method: "PUT",
    },
    PUT_LAB: {
        uri: () => {
            return `api/v4/carts/preferences?types=labs`
        },
        method: "PUT",
    },
    ADD_SKU: {
        uri: () => {
            return `api/v4/carts/skus`
        },
        method: "POST",
    },
    REMOVE_SKU: {
        uri: () => {
            return `api/v4/carts/skus`
        },
        method: "DELETE",
    },
    HOME: {
        uri: (city) => {
            return `${gatewayPrefix}v1/home?city=${city}`
        },
        method: "GET",
    },
    PDP: {
        uri: (testId, city, isChildPDPPage) => {
            let url = `${gatewayPrefix}v1/test/${testId}?city=${city}`
            if (isChildPDPPage) url = url + "&show_info_for=city_page"
            return url
        },
        method: "GET",
    },
    INFORMATION_FEEDBACK: {
        uri: (testId) => {
            return `${gatewayPrefix}v1/test/${testId}/feedback`
        },
        method: "POST",
    },
    CATEGORY_NAVIGATION: {
        uri: (category_name, city) => {
            return `${gatewayPrefix}v1/browse-categories/${category_name}?city=${city}`
        },
        method: "GET",
    },
    GET_CART: {
        uri: () => {
            return "/api/v4/carts/brief?types=labs"
        },
        method: "GET",
    },
    UPDATE_PREFERENCE: {
        uri: () => {
            return `api/v4/carts/preferences?types=labs`
        },
        method: "PUT",
    },
}

export const webviewHeaderCta = {
    CART: "cart",
    LOCATION: "location",
    SEARCH: "search",
}

// SEO (meta title, description, etc)

export const PDP_META_TITLE = "Book <test_name> Online - Price, Purpose & Preparation"
export const PDP_META_DESCRIPTION =
    "Book <test_name> online at best price on 1MG Labs. Get details on procedure, preparation, normal range & diagnostic benefits. Get home sample collection with certified labs."
